import { SubscriptionPlan } from "../entities/SubscriptionPlan";
import { SubscriptionsRepository } from "../repositories/SubscriptionsRepository";

export class GetSubscriptionAll {
	constructor(private repository: SubscriptionsRepository) {}

	execute(): Promise<SubscriptionPlan[]> {
		return this.repository.getSubscriptionAll();
	}
}
